import { FC, ReactNode } from 'react'
import styled from 'styled-components'
import SlickSlider, { Settings } from 'react-slick'
import { colorPallet } from '../styles/colors'

type SliderProps = {
  children: ReactNode
}

export const Slider: FC<SliderProps> = (props) => {
  const { children } = props
  const slidesToShow = window.outerWidth >= 767 ? 2 : 1

  const settings: Settings = {
    dots: false,
    speed: 500,
    slidesToShow: slidesToShow,
    slidesToScroll: 1,
    arrows: true,
    infinite: false,
  }
  return (
    <StyledSliderWrap>
      <SlickSlider {...settings}>{children}</SlickSlider>
    </StyledSliderWrap>
  )
}

const StyledSliderWrap = styled.div`
  .slick-slider {
    position: relative;
    display: block;
    box-sizing: border-box;
    user-select: none;
    touch-action: pan-y;
  }
  .slick-list {
    position: relative;
    overflow: hidden;
    display: block;
    margin: 0 0 0 30px;

    &:focus {
      outline: none;
    }

    &.dragging {
      cursor: pointer;
      cursor: hand;
    }

    @media (max-width: 767px) {
      margin: 0 0 0 10vw;
    }
  }
  .slick-slider .slick-track,
  .slick-slider .slick-list {
    transform: translate3d(0, 0, 0);
  }

  .slick-track {
    position: relative;
    left: 0;
    top: 0;
    display: block;
    margin-left: auto;
    margin-right: auto;

    &:before,
    &:after {
      content: '';
      display: table;
    }

    &:after {
      clear: both;
    }

    .slick-loading & {
      visibility: hidden;
    }
  }
  .slick-initialized .slick-slide {
    display: block;
  }
  .slick-loading .slick-slide {
    visibility: hidden;
  }
  .slick-vertical .slick-slide {
    display: block;
    height: auto;
    border: 1px solid transparent;
  }
  .slick-slide {
    float: left;
    height: 100%;
    min-height: 1px;
    [dir='rtl'] & {
      float: right;
    }
    img {
      display: block;
    }
    &.slick-loading img {
      display: none;
    }

    display: none;

    &.dragging img {
      pointer-events: none;
    }
  }
  .slick-arrow.slick-hidden {
    display: none;
  }

  //arrow
  .slick-prev,
  .slick-next {
    position: absolute;
    display: block;
    height: 20px;
    width: 20px;
    line-height: 0px;
    font-size: 0px;
    cursor: pointer;
    background: transparent;
    top: 50%;
    transform: translate(0, -50%);
    padding: 0;
    border: none;
    outline: none;
    &:hover,
    &:focus {
      outline: none;
      background: transparent;
      &:before {
        opacity: 1;
      }
    }
    &.slick-disabled {
      cursor: default;
      &:before {
        opacity: 0.2;
      }
    }
    &:before {
      font-size: 20px;
      line-height: 1;
      opacity: 1;
    }
  }

  .slick-prev {
    left: -25px;

    &:before {
      content: '';
      display: inline-block;
      width: 15px;
      height: 15px;
      border-left: 2px solid ${colorPallet.primary};
      border-bottom: 2px solid ${colorPallet.primary};
      transform: rotate(45deg);
      position: absolute;
      top: 0;
      left: 13px;
    }

    @media (max-width: 767px) {
      left: 1vw;
    }
  }

  .slick-next {
    right: -25px;

    &:before {
      content: '';
      display: inline-block;
      width: 15px;
      height: 15px;
      border-right: 2px solid ${colorPallet.primary};
      border-top: 2px solid ${colorPallet.primary};
      transform: rotate(45deg);
      position: absolute;
      top: 0;
      left: 13px;
    }

    @media (max-width: 767px) {
      right: 6vw;
    }
  }
`
